import * as z$1 from "zod/v4";
//#region src/schemas/http/execution-recovery.ts
const requiredIdentifierSchema = z$1.string().trim().min(1).max(512);
const nullableIdentifierSchema = requiredIdentifierSchema.nullable();
const executionRecoveryActionSchema = z$1.enum([
	"recover_result",
	"resume_controller_conversation",
	"retry_as_new_execution"
]);
const executionRecoveryTierSchema = z$1.enum([
	"durable_result_replay",
	"exact_controller_conversation_resume",
	"fresh_execution",
	"manual_review",
	"none"
]);
const executionRecoveryDestinationSchema = z$1.discriminatedUnion("surface", [z$1.strictObject({
	surface: z$1.literal("space"),
	spaceId: requiredIdentifierSchema,
	threadId: nullableIdentifierSchema
}), z$1.strictObject({
	surface: z$1.enum(["slack", "lark"]),
	conversationId: requiredIdentifierSchema,
	messageId: nullableIdentifierSchema,
	spaceId: requiredIdentifierSchema
})]);
const executionRecoveryIdentitySchema = z$1.strictObject({
	spaceId: requiredIdentifierSchema,
	dispatchId: requiredIdentifierSchema,
	attemptId: nullableIdentifierSchema,
	taskId: nullableIdentifierSchema,
	targetProfileId: requiredIdentifierSchema,
	runtimeCoordinatorExecutionId: nullableIdentifierSchema,
	resultRef: nullableIdentifierSchema,
	agentControllerRef: nullableIdentifierSchema,
	agentControllerConversationId: nullableIdentifierSchema
});
const executionRecoveryActionCapabilitySchema = z$1.strictObject({
	action: executionRecoveryActionSchema,
	enabled: z$1.boolean(),
	label: z$1.enum([
		"Recover result",
		"Recover reply",
		"Continue conversation",
		"Start a new Wake",
		"Retry as new execution"
	]),
	reasonCode: requiredIdentifierSchema,
	warning: z$1.string().trim().min(1).max(1e3).nullable()
});
const executionRecoveryProjectionSchema = z$1.strictObject({
	identity: executionRecoveryIdentitySchema,
	destination: executionRecoveryDestinationSchema,
	tier: executionRecoveryTierSchema,
	status: z$1.enum([
		"available",
		"in_progress",
		"recovered",
		"outcome_unknown",
		"unavailable"
	]),
	recommendedAction: executionRecoveryActionSchema.nullable(),
	actions: z$1.strictObject({
		recoverResult: executionRecoveryActionCapabilitySchema,
		resumeControllerConversation: executionRecoveryActionCapabilitySchema,
		retryAsNewExecution: executionRecoveryActionCapabilitySchema
	}),
	recoveredPublicationId: nullableIdentifierSchema,
	updatedAtMs: z$1.number().int().nonnegative()
});
const inspectExecutionRecoveryQuerySchema = z$1.strictObject({ dispatchId: requiredIdentifierSchema });
const inspectExecutionRecoveryResponseSchema = z$1.strictObject({ recovery: executionRecoveryProjectionSchema });
const executeExecutionRecoveryBodySchema = z$1.strictObject({
	action: executionRecoveryActionSchema,
	operationId: requiredIdentifierSchema,
	expectedIdentity: executionRecoveryIdentitySchema,
	destination: executionRecoveryDestinationSchema
});
const executeExecutionRecoveryResponseSchema = z$1.strictObject({
	status: z$1.enum([
		"already_completed",
		"completed",
		"new_execution_requested",
		"outcome_unknown",
		"retry_later"
	]),
	action: executionRecoveryActionSchema,
	operationId: requiredIdentifierSchema,
	recovery: executionRecoveryProjectionSchema,
	publicationId: nullableIdentifierSchema,
	newExecutionId: nullableIdentifierSchema,
	reasonCode: requiredIdentifierSchema
});
//#endregion
export { executeExecutionRecoveryBodySchema, executeExecutionRecoveryResponseSchema, executionRecoveryActionCapabilitySchema, executionRecoveryActionSchema, executionRecoveryDestinationSchema, executionRecoveryIdentitySchema, executionRecoveryProjectionSchema, executionRecoveryTierSchema, inspectExecutionRecoveryQuerySchema, inspectExecutionRecoveryResponseSchema };

//# sourceMappingURL=execution-recovery.js.map